import React from "react";
import { Checkbox as MuiCheckbox } from "@mui/material";

const Checkbox = React.forwardRef((props, ref) => {
    const { color, ...moreProps } = props;
    return <MuiCheckbox {...moreProps} color={color ? color : "primary"} ref={ref} />;
});

export default Checkbox;
